import { useNavigate } from 'react-router-dom';
import { EmptyState } from '@/components/feedback';
import { MobileHeader } from '@/components/mobile-shell/MobileHeader';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="tm-shell">
      <MobileHeader title="Page not found" backTo="/mobile/home" backLabel="Home" />
      <main className="tm-main tm-main--no-nav" id="tm-main" tabIndex={-1}>
        <EmptyState
          title="We could not find that page"
          body="The link may be out of date. Go back to your home screen to carry on."
          action={
            <button type="button" className="tm-btn" onClick={() => navigate('/mobile/home')}>
              Go to Home
            </button>
          }
        />
      </main>
    </div>
  );
}
